<ng-container #candidate *ngIf="{ candidate: candidate$ | async } as result">
  <div mat-dialog-title>
    <div class="d-flex" style="margin-bottom: 20px">
      <div style="width: 102px; margin-right: 20px">
        <div
          style="width: 102px; height: 102px; border-radius: 50%; background-size: cover; background-position: center"
          [ngStyle]="{ 'background-image': 'url(' + result.candidate?.imgUrl + ')' }"
          *ngIf="result.candidate?.imgUrl"></div>
        <app-user-avatar [name]="result.candidate?.displayName" [size]="'102px'" class="pe-2 flex-shrink-0" *ngIf="!result.candidate?.imgUrl"></app-user-avatar>
       <mat-spinner   *ngIf="!result.candidate" class="m-1" [diameter]="30" color="accent"></mat-spinner>
      </div>

      <div style="flex-grow: 1; width: 25%; display: inline-block; vertical-align: top; font-size: initial">
        <div class="text-truncate text-nowrap" *ngIf="result.candidate">
          <div class="d-flex align-items-center mb-2">
            <div class="fw-medium text-truncate text-nowrap" style="font-size: 20px; line-height: 25px; color: #030303">
              {{ result.candidate?.displayName ? (result.candidate?.displayName | titlecase) : 'Name unavailable' }}
            </div>
                          
            <div class="body-md fw-normal me-1" style="margin-left: 8px; padding: 4px 6px; border-radius: 4px; background-color: #FFC5CA" *ngIf="result.candidate?.isRestricted === CandidateRestrictionStatus.RESTRICTED">Restricted</div>
          </div>

          <div class="mb-1 body-md fw-medium mat-color-gray-600 text-truncate text-nowrap body-lg" style="height: 20px; color: #5e5e5e">
            {{ result.candidate?.jobTitle ? (result.candidate?.jobTitle | titlecase) : 'Job Title Unavailable' }}
          </div>
          <div class="mb-3 body-md fw-normal mat-color-gray-600 truncate-2-lines" style="height: 36px; color: #5e5e5e">
            {{ result.candidate?.companyName ? (result.candidate?.companyName | titlecase) : 'Company Name Unavailable' }}
          </div>
        </div>
       

      </div>

      <div class="text-nowrap text-truncate" style="flex-grow: 1; width: 25%">
        <div class="w-100 text-nowrap text-truncate">
          <ng-container *ngIf="result.candidate">
            <div class="text-nowrap text-truncate">
              <div class="d-flex align-items-center header text-truncate text-nowrap">
                <mat-icon class="md-icon-20 flex-shrink-0" color="primary">mail_outline</mat-icon>
                <mat-spinner class="ms-3" color="accent" *ngIf="loading" [diameter]="16"></mat-spinner>
                <ng-container *ngIf="!loading">
                  <span class="d-block ms-2 body-md fw-normal mat-color-gray-600 text-truncate text-nowrap">{{ result.candidate.email || 'No email available' }} </span>
                  <a class="d-block ms-2 body-md c-pointer fw-normal" style="text-decoration: none;" [matTooltip]="result.candidate.emailsString" *ngIf="result.candidate && result.candidate.emails.length - 1 > 0">
                    + {{ result.candidate.emails.length - 1 }} more
                  </a>
                </ng-container>
              </div>

              <div class="d-flex align-items-center header mt-2">
                <mat-icon class="md-icon-20 flex-shrink-0" color="primary">phone</mat-icon>
                <mat-spinner class="ms-3" color="accent" *ngIf="loading" [diameter]="16"></mat-spinner>
                <ng-container *ngIf="!loading">
                  <span class="d-block ms-2 fw-normal body-md mat-color-gray-600 text-truncate text-nowrap"
                    >{{ result.candidate.mobilePhone || result.candidate.homePhone || 'No phone available' }}
                  </span>
                  <a class="d-block ms-2 c-pointer fw-normal body-md" [matTooltip]="result.candidate.phonesString" *ngIf="result.candidate && result.candidate.phones.length - 1 > 0">
                    + {{ result.candidate.phones.length - 1 }} more
                  </a>
                </ng-container>
              </div>

              <div class="d-flex align-items-start header mt-2">
                <mat-icon class="md-icon-20 flex-shrink-0">location_on</mat-icon>
                <mat-spinner class="ms-3" color="accent" *ngIf="loading" [diameter]="16"></mat-spinner>
                <ng-container *ngIf="!loading">
                  <span class="d-block ms-2 fw-normal body-md mat-color-gray-600 text-truncate truncate-2-lines"> {{ result.candidate.cityState || 'No location' }}</span>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div style="width: 250px">
        <div class="d-flex align-items-center justify-content-end" style="margin-bottom: 25px">
          <ng-container *ngIf="data.total > 0">
            <button
              style="margin-right: 16px; width: 28px; min-width: 28px; height: 28px; border-width: 1px !important"
              class="d-flex justify-content-center align-items-center p-0"
              mat-stroked-button
              color="primary"
              (click)="previous()">
              <mat-icon class="me-0 md-icon-30 mat-color-gray-600" style="margin-left: -2px">chevron_left</mat-icon>
            </button>
            <span class="body-lg"> {{ data.offset + currentIndex + 1 }} / {{ data.total }}</span>
            <button
              style="margin-left: 16px; width: 28px; min-width: 28px; height: 28px; border-width: 1px !important"
              class="d-flex justify-content-center align-items-center p-0"
              [disabled]="currentIndex + 1 === data.total"
              mat-stroked-button
              color="primary"
              (click)="next()">
              <mat-icon class="me-0 md-icon-30 mat-color-gray-600" style="margin-left: -2px">chevron_right</mat-icon>
            </button>
          </ng-container>

          <mat-icon class="md-icon-30 mat-color-gray-600" style="color: #5e5e5e" mat-dialog-close style="margin-left: 16px">close</mat-icon>
        </div>

        <div>
          <ng-container
                *ngIf="{
                    outreach: outreachInfo$ | async, 
                  } as info">
           <ng-container *ngIf="info.outreach" >
                  
          <div class="d-flex flex-row justify-content-end body-md text-nowrap mat-color-gray-600" *ngIf="info.outreach?.lastContactDate">
            <span class="d-block fw-normal">Last contacted&nbsp;</span>
            <span class="fw-medium">{{ info.outreach.lastContactDate | formatUnixDate }}</span>
          </div>

          <div
            class="mt-1 d-flex flex-row justify-content-end body-md text-nowrap mat-color-gray-600"
            *ngIf="data.viewType === PipelineTabIndexes.SOURCE || data.viewType === PipelineTabIndexes.SELECT">
            <span class="d-block fw-normal">Next outreach&nbsp;</span>
            <span class="fw-medium">{{ info.outreach.nextOutreachStep }}</span>
          </div>

          <div
            class="mt-1 d-flex flex-row justify-content-end body-md text-nowrap mat-color-gray-600"
            *ngIf="data.viewType === PipelineTabIndexes.SOURCE || data.viewType === PipelineTabIndexes.SELECT">
            <span class="d-block fw-normal">Next outreach date&nbsp;</span>
            <span class="fw-medium">{{ info.outreach.nextOutreachDate | formatUnixDate }}</span>
          </div>

          <div class="mt-1 d-flex flex-row justify-content-end body-md text-nowrap mat-color-gray-600" *ngIf="data.viewType === PipelineTabIndexes.APPLICANTS">
            <span class="d-block fw-normal">Applied date&nbsp;</span>
            <span class="fw-medium">{{ info.outreach.appliedDate | formatUnixDate }}</span>
          </div>

          <div class="mt-1 d-flex flex-row justify-content-end body-md text-nowrap mat-color-gray-600" *ngIf="data.viewType === PipelineTabIndexes.APPLICANTS">
            <span class="d-block fw-normal">Applied from&nbsp;</span>
            <span class="fw-medium">{{ info.outreach.appliedFrom }}</span>
          </div>
          </ng-container>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <a
          class="text-decoration-none me-2"
          style="width: 110px"
          target="_blank"
          matTooltip="Preview Resume"
          (click)="$event.stopPropagation(); previewResume()"
          [ngClass]="{ 'icon-url-disabled': result.candidate?.haveResumeFlag !== 1 }">
          <button mat-stroked-button style="height: 36px">
            <mat-icon class="md-icon-18" color="primary">preview</mat-icon>
            Resume
          </button>
        </a>

        <a
          class="text-decoration-none me-2"
          [href]="result.candidate?.linkedInUrl"
          target="_blank"
          [matTooltip]="result.candidate?.linkedInUrl"
          (click)="$event.stopPropagation()"
          [ngClass]="{ 'icon-url-disabled': !result.candidate?.linkedInUrl }">
          <button mat-stroked-button style="width: 36px; min-width: 36px; height: 36px; padding: 0">
            <mat-icon fontSet="fab" fontIcon="fa-linkedin" class="md-icon-16 m-0" color="primary"></mat-icon>
          </button>
        </a>

        <a
          class="text-decoration-none me-2"
          [href]="result.candidate?.indeedUrl"
          target="_blank"
          [matTooltip]="result.candidate?.indeedUrl"
          (click)="$event.stopPropagation()"
          [ngClass]="{ 'icon-url-disabled': !result.candidate?.indeedUrl }">
          <button mat-stroked-button style="width: 36px; min-width: 36px; height: 36px; padding: 0">
            <mat-icon svgIcon="indeed" class="md-icon-20 ms-0 me-0" style="margin-top: -6px" color="primary"></mat-icon>
          </button>
        </a>

        <mat-icon class="md-icon-26 cursor-pointer" color="primary" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">more_vert</mat-icon>

        <mat-menu #menu="matMenu" class="m-0 resume-menu">
          <div>
            <button 
              mat-flat-button 
              class="w-100 d-flex justify-content-start align-items-center" 
              style="height: 36px" 
              (click)="$event.stopPropagation(); uploadResumes(result.candidate.profileRef)">
              <mat-icon class="md-icon-20 ms-0 mt-0 me-3" color="primary">upload</mat-icon>
              Upload resume
            </button>
            <button 
              mat-flat-button 
              style="height: 36px" 
              class="w-100 d-flex justify-content-start align-items-center" 
              [ngClass]="{ 'icon-url-disabled': result.candidate?.haveResumeFlag !== 1 }"
              (click)="$event.stopPropagation(); downlodResume()">
              <mat-icon class="md-icon-20 ms-0 mt-0 me-3" color="primary">download</mat-icon>
              Download resume
            </button>
            <button
              mat-flat-button
              style="height: 36px"
              class="w-100 d-flex justify-content-start align-items-center"
              [ngClass]="{ 'icon-url-disabled': result.candidate?.canRequestContactInfoFlag !== 1 }"
              (click)="$event.stopPropagation(); requestCandidateInfo()">
              <mat-icon class="md-icon-20 ms-0 mt-0 me-3" color="primary">contact_mail</mat-icon>
              Request contact
            </button>
          </div>
        </mat-menu>
      </div>

      <div class="d-flex align-items-center">
        <button
          mat-stroked-button
          style="width: 32px; min-width: 32px; height: 32px; padding: 0"
          matTooltipPosition="left"
          matTooltip="Hide"
          *ngIf="(data.viewType === PipelineTabIndexes.SEARCH && data.priorityId !== '6000') || data.viewType === PipelineTabIndexes.SOURCE"
          (click)="hide()">
          <mat-icon class="md-icon-20 ms-0 me-0" color="primary">visibility_off</mat-icon>
        </button>

        <button
          mat-stroked-button
          style="margin-left: 16px; width: 32px; min-width: 32px; height: 32px; padding: 0"
          matTooltipPosition="left"
          matTooltip="Unhide"
          *ngIf="data.viewType === PipelineTabIndexes.SEARCH && data.priorityId === '6000'"
          (click)="unhide()">
          <mat-icon class="md-icon-20 ms-0 me-0" color="primary">visibility</mat-icon>
        </button>

        <button
          mat-stroked-button
          style="margin-left: 16px; width: 32px; min-width: 32px; height: 32px; padding: 0"
          matTooltipPosition="left"
          matTooltip="Add to source"
          *ngIf="data.viewType === PipelineTabIndexes.SEARCH && data.priorityId !== '6000'"
          (click)="addToCampaign()">
          <mat-icon class="md-icon-20 ms-0 me-0" color="primary">campaign</mat-icon>
        </button>

        <button
          mat-stroked-button
          style="margin-left: 16px; width: 32px; min-width: 32px; height: 32px; padding: 0"
          matTooltipPosition="left"
          matTooltip="Email"
          *ngIf="data.viewType === PipelineTabIndexes.SOURCE || data.viewType === PipelineTabIndexes.APPLICANTS || data.viewType === PipelineTabIndexes.SELECT"
          (click)="promptSendEmailModal(0)">
          <mat-icon class="md-icon-20 ms-0 me-0" color="primary">mail</mat-icon>
        </button>

        <button
          mat-stroked-button
          style="margin-left: 16px; width: 32px; min-width: 32px; height: 32px; padding: 0"
          *ngIf="
            (data.viewType === PipelineTabIndexes.SOURCE || data.viewType === PipelineTabIndexes.APPLICANTS || data.viewType === PipelineTabIndexes.SELECT) &&
            (authService.recruiterId === 1 || authService.recruiterId === 2)"
            (click)="openSmsChat()">
          <mat-icon class="md-icon-20 ms-0 me-0" color="primary">sms</mat-icon>
        </button>

        <button
          mat-stroked-button
          style="margin-left: 16px; width: 32px; min-width: 32px; height: 32px; padding: 0"
          matTooltipPosition="left"
          matTooltip="Reject"
          *ngIf="data.viewType === PipelineTabIndexes.APPLICANTS || data.viewType === PipelineTabIndexes.SELECT"
          (click)="rejectApplicant()">
          <mat-icon class="md-icon-24 ms-0 me-0" color="warn">close</mat-icon>
        </button>

        <button
          mat-stroked-button
          style="margin-left: 16px; width: 32px; min-width: 32px; height: 32px; padding: 0"
          matTooltipPosition="left"
          matTooltip="Accept"
          *ngIf="data.viewType === PipelineTabIndexes.APPLICANTS"
          (click)="acceptApplicants()">
          <mat-icon class="md-icon-24 ms-0 me-0 mat-color-green-800">check</mat-icon>
        </button>

        <mat-icon class="md-icon-26 cursor-pointer" style="margin-left: 12px" color="primary" [matMenuTriggerFor]="moreMenu" (click)="$event.stopPropagation()">more_vert</mat-icon>

        <mat-menu #moreMenu="matMenu" class="m-0 resume-menu">
          <div>
            <button 
              mat-flat-button 
              class="w-100 d-flex justify-content-start align-items-center" 
              style="height: 36px" 
              [disabled]="isCandidateUpdating"
              (click)="$event.stopPropagation(); handleRestriction()"
              *ngIf="result.candidate?.isRestricted; else restrict">
              <mat-icon class="md-icon-20 ms-0 mt-0 me-3" color="primary">do_not_disturb_on</mat-icon>
              Un-Restrict
            </button>

            <ng-template #restrict>
              <button 
                mat-flat-button 
                class="w-100 d-flex justify-content-start align-items-center" 
                style="height: 36px" 
                [disabled]="isCandidateUpdating"
                (click)="$event.stopPropagation(); handleRestriction()">
                <mat-icon class="md-icon-20 ms-0 mt-0 me-3" style="transform: scaleX(-1)" color="primary">block</mat-icon>
                Restrict
              </button>
            </ng-template>

            <button 
              mat-flat-button 
              class="w-100 d-flex justify-content-start align-items-center" 
              style="height: 36px" 
              *ngIf="!data.isOmniSearch"
              [disabled]="isCandidateUpdating"
              (click)="$event.stopPropagation(); stage()">
              <mat-icon class="md-icon-20 ms-0 mt-0 me-3" color="primary">sync_alt</mat-icon>
              Change Stage
            </button>

            <button 
              mat-flat-button 
              class="w-100 d-flex justify-content-start align-items-center" 
              style="height: 36px" 
              [disabled]="isCandidateUpdating"
              (click)="$event.stopPropagation(); addToSelection$.next(1);">
              <mat-icon class="md-icon-20 ms-0 mt-0 me-3" color="primary">add_circle</mat-icon>
              Add to Job
            </button>

            <div style="padding: 16px 16px 0;" *ngIf="addToSelection$.value === 1">
              <app-input-select
                class="d-inline-flex"
                label="Job"
                iconSuffix="search"
                [api]="searchLocation"
                fieldClass="w-100 mat-color-gray-600"
                (click)="$event.stopPropagation();"
                (valueChange)="addToJob($event)">
              </app-input-select>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="p-0" style="max-height: 72vh !important" mat-dialog-content>
    <div class="w-100" style="height: 34px"></div>
    <div>
      <mat-tab-group class="candidate-popout-tabs h-100" [selectedIndex]="TabSelected$ | async" (selectedIndexChange)="TabSelected$.next($event)">
        <mat-tab label="Overview" class="capitalize-first-letter">
          <div *ngIf="TabSelected$.value === 0">
            <div class="tab-content mat-background-gray-50" style="padding: 37px 20px 20px; min-height: 70vh;">
              <ng-container
                *ngIf="{
                    overview: overview$ | async, 
                  } as results">
                  <div class="left-panel">
                    <div *ngIf="!results.overview?.experience?.length && !results.overview?.education?.length && !results.overview?.skills?.length && !results.overview?.certifications?.length">
                      No data available
                    </div>

                    <div *ngIf="results.overview && results.overview.experience.length > 0" style="margin-bottom: 20px;">
                      <mat-expansion-panel class="custom-panel bg-white" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title> Experience </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div *ngFor="let item of results.overview?.experience; let i = index">
                          <div class="d-flex flex-column" style="padding: 8px 0">
                            <div class="d-flex flex-row">
                              <div class="w-50 d-flex align-items-center">
                                <span class="d-block body-md fw-medium"> {{ item.companyName ? (item.companyName | titlecase) : ' ' }} </span>
                              </div>
                              <div class="w-50 d-flex flex-row justify-content-end">
                                <span class="d-block body-md fw-medium">{{ item.experienceDuration.fromDate }} - {{ item.experienceDuration.toDate }}</span>
                              </div>
                            </div>

                            <div *ngFor="let experience of item.experience; let i = index" style="margin-top: 4px">
                              <div class="d-flex">
                                <div class="w-50">
                                  <span class="d-flex align-items-center body-md text-capitalize">
                                    <div class="mat-background-gray-400 me-2 position-relative" [ngClass]="i > 0 ? 'timeline' : ''" style="width: 4px; height: 4px; border-radius: 50%"></div>
                                    {{ experience.title || 'Not provided' }}
                                  </span>
                                </div>
                                <div class="w-50 d-flex flex-row align-items-center justify-content-end">
                                  <span class="d-block body-sm"> {{ experience.fromDate | shortDate }} {{ experience.toDate ? '- ' + (experience.toDate | shortDate) : ' ' }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div *ngIf="results.overview && results.overview.education.length > 0" style="margin-bottom: 20px;">
                      <mat-expansion-panel class="custom-panel bg-white" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title> Education </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div *ngFor="let item of results.overview?.education; let i = index">
                          <div class="d-flex flex-column" style="padding: 8px 0">
                            <div class="d-flex flex-row">
                              <div class="w-50 d-flex align-items-center">
                                <span class="d-block body-md fw-medium"> {{ item.schoolName ? (item.schoolName | titlecase) : ' ' }} </span>
                              </div>
                              <div class="w-50 d-flex flex-row justify-content-end">
                                <span class="d-block body-md fw-medium"> {{ item.fromDate | shortDate }} {{ item.toDate ? '- ' + (item.toDate | shortDate) : ' ' }}</span>
                              </div>
                            </div>

                            <div class="d-flex flex-row mt-1" *ngIf="item.major || item.degreeName">
                              <div>
                                <span class="d-flex align-items-center">
                                  {{ item.degreeName }}
                                  <ng-container *ngIf="item.major">
                                    <div class="mat-background-gray-400 mx-2 position-relative" style="width: 4px; height: 4px; border-radius: 50%"></div>
                                    {{ item.major }}
                                  </ng-container>
                                </span>
                                <span class="invisible" *ngIf="!item.major && !item.degreeName"> no-data </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div *ngIf="results.overview && results.overview.certifications.length > 0" style="margin-bottom: 20px;">
                      <mat-expansion-panel class="custom-panel bg-white" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title> Certifications </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div *ngFor="let item of results.overview?.certifications; let i = index">
                          <div style="padding: 8px 0">
                            <div>
                              <span class="d-block body-md fw-medium"> {{ item.skillName ? (item.skillName | titlecase) : ' ' }} </span>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div *ngIf="results.overview && results.overview.skills.length > 0">
                      <mat-expansion-panel class="custom-panel bg-white" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title> Skills </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="d-flex flex-wrap" style="padding-top: 10px; padding-bottom: 16px; gap: 12px">
                          <div 
                            *ngFor="let item of results.overview?.skills; let i = index" 
                            class="mat-background-gray-100" 
                            style="padding: 4px; border: 1px solid #E0E0E0; border-radius: 4px;">
                            {{ item.skillName }}
                        </div>
                        </div>
                      </mat-expansion-panel>
                    </div>
                  </div>

                  <div class="right-panel">
                    <div class="bg-white activity-panel-container" style="min-height: 100%; border: 1px solid #E0E0E0; border-radius: 4px; padding: 20px 16px;">
                      <div style="font-size: 20px; color: #030303" class="fw-medium">Activity</div>
                      <ng-container *ngIf="candidateActivities.length > 0; else noActivities">
                        <div *ngFor="let item of candidateActivities">
                          <mat-expansion-panel class="custom-panel activity-panel bg-white" expanded="true">
                            <mat-expansion-panel-header class="bg-white px-0 pb-0">
                              <mat-panel-title>
                                {{ item.date | formatMonthYear }}
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div *ngFor="let activity of item.activities" class="activity-entry bg-white p-0" style="margin-top: 16px;">
                              <div class="d-flex flex-column">
                                <div class="d-flex flex-row">
                                  <div class="w-100">
                                    <div class="body-md fw-medium">{{ activity.title }}</div>
                                    <div>
                                      {{ activity.createdDate * 1000 | date }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-row mt-1">
                                  <div class="w-100">
                                    <span class="body-md mat-color-gray-600">{{ activity.summaryDesc }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </div>
                      </ng-container>
                      <ng-template #noActivities>
                        <div style="margin-top: 16px;">No activity</div>
                      </ng-template>
                    </div>
                  </div>

                
              </ng-container>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Credentials" class="capitalize-first-letter">
          <div>
            <div class="tab-content mat-background-gray-50" style="padding: 37px 20px 20px; min-height: 70vh;">
              <ng-container
                *ngIf="{
                    credentials: credentials$ | async, 
                  } as results">
                  <div class="left-panel">
                    <div *ngIf="results.credentials && results.credentials.clinicalEnrollments.length > 0" style="margin-bottom: 20px;">
                      <mat-expansion-panel class="custom-panel full-height bg-white" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title>Enrollments</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div style="padding-bottom: 16px;" *ngFor="let enrollment of results.credentials.clinicalEnrollments | groupByPipe : 'enrollmentId'; let i = index">
                          <mat-expansion-panel class="custom-panel full-height bg-white inner-panel" expanded="true">
                            <mat-expansion-panel-header>
                              <mat-panel-title>Enrollment {{ i + 1 }}</mat-panel-title>
                            </mat-expansion-panel-header>

                            <div>
                              <div class="text-truncate" style="margin-bottom: 16px;">
                                <div class="mb-1 body-sm text-truncate">Clinician enrollment ID</div>
                                <div class="fw-medium text-truncate">{{ enrollment.value[0]?.enrollmentId || '-' }}</div>
                              </div>

                              <div class="w-100 d-flex" style="margin-bottom: 16px;">
                                <div class="w-50 text-truncate">
                                  <div class="mb-1 body-sm text-truncate">Clinician primary specialty</div>
                                  <div class="fw-medium text-truncate">{{ enrollment.value[0]?.primarySpecialty || '-' }}</div>
                                </div>
                                <div class="w-50 text-truncate">
                                  <div class="mb-1 body-sm text-truncate">Subspecialty</div>
                                  <div class="fw-medium text-truncate">{{ enrollment.value[0]?.secondarySpecialty || '-' }}</div>
                                </div>
                              </div>

                              <div class="w-100 d-flex">
                                <div class="w-50 text-truncate">
                                  <div class="mb-1 body-sm text-truncate">Clinician accepts medicare assignment</div>
                                  <div class="fw-medium text-truncate">{{ enrollment.value[0]?.individualMedicareAssignmentFlag || '-' }}</div>
                                </div>
                                <div class="w-50 text-truncate">
                                  <div class="mb-1 body-sm text-truncate">Clinician accepts telehealth</div>
                                  <div class="fw-medium text-truncate">{{ enrollment.value[0]?.telehealth || '-' }}</div>
                                </div>
                              </div>

                              <div style="padding-left: 16px;">
                                <mat-expansion-panel class="custom-panel full-height bg-white inner-panel" expanded="true" *ngFor="let organization of enrollment.value; let orgIndex = index;">
                                  <mat-expansion-panel-header>
                                    <mat-panel-title>Organization {{ orgIndex + 1 }}</mat-panel-title>
                                  </mat-expansion-panel-header>

                                  <div>
                                    <div class="w-100 d-flex" style="margin-bottom: 16px;">
                                      <div class="w-50 text-truncate">
                                        <div class="mb-1 body-sm text-truncate">Enrollment organization name</div>
                                        <div class="fw-medium text-truncate">{{ organization.companyName || '-' }}</div>
                                      </div>
                                      <div class="w-50 text-truncate">
                                        <div class="mb-1 body-sm text-truncate">Organization PAC ID</div>
                                        <div class="fw-medium text-truncate">{{ organization.companyId || '-' }}</div>
                                      </div>
                                    </div>

                                    <div class="w-100 d-flex" style="margin-bottom: 16px;">
                                      <div class="w-50 text-truncate">
                                        <div class="mb-1 body-sm text-truncate">Enrollment organization address</div>
                                        <div class="fw-medium text-truncate">
                                          <span *ngIf="!organization.addressLine1 && organization.addressLine2 && !organization.cityState; else addressTemplate"></span>  
                                          <ng-template #addressTemplate>
                                            <span> {{ organization.addressLine1 }} {{ organization.addressLine2 }} {{ organization.cityState }} </span>
                                          </ng-template>
                                        </div>
                                      </div>
                                      <div class="w-50 text-truncate">
                                        <div class="mb-1 body-sm text-truncate">Enrollment org. phone</div>
                                        <div class="fw-medium text-truncate">{{ organization.phoneNumber || '-' }}</div>
                                      </div>
                                    </div>

                                    <div class=" text-truncate">
                                      <div class="mb-1 body-sm text-truncate">Organization accepts medicare assignment</div>
                                      <div class="fw-medium text-truncate">{{ organization.individualMedicareAssignmentFlag || '-' }}</div>
                                    </div>
                                  </div>
                                </mat-expansion-panel>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div *ngIf="results.credentials && results.credentials.licenses.length > 0">
                      <mat-expansion-panel class="custom-panel full-height bg-white" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title>Licenses</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div>
                          <div 
                            class="w-100" 
                            style="margin-top: 16px; margin-bottom: 16px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px 32px;"
                            *ngFor="let license of results.credentials.licenses; let i = index">
                            <div class="text-truncate">
                              <div class="mb-1 body-sm text-truncate">Issuing Body</div>
                              <div class="fw-medium text-truncate">{{ license.state }}</div>
                            </div>
                            <div class="text-truncate">
                              <div class="mb-1 body-sm text-truncate">License No.</div>
                              <div class="fw-medium text-truncate">{{ license.licensenumber }}</div>
                            </div>
                            <div class="text-truncate">
                              <div class="mb-1 body-sm text-truncate">License Type</div>
                              <div class="fw-medium text-truncate">{{ license.licenseType }}</div>
                            </div>
                            <div class="text-truncate">
                              <div class="mb-1 body-sm text-truncate">Enumeration Date</div>
                              <div class="fw-medium text-truncate">{{ license.issueDate | date:'MMMM d, y' }}</div>
                            </div>
                            <div class="text-truncate">
                              <div class="mb-1 body-sm text-truncate">NPI</div>
                              <div class="fw-medium text-truncate">{{ license.sourceId }}</div>
                            </div>
                            <div class="text-truncate">
                              <div class="mb-1 body-sm text-truncate">PAC ID</div>
                              <div class="fw-medium text-truncate">{{ license.externalId }}</div>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div *ngIf="!results.credentials?.clinicalEnrollments.length && !results.credentials?.licenses.length">
                      No data available
                    </div>

                  </div>

                  <div class="right-panel">
                     <div class="bg-white activity-panel-container" style="min-height: 100%; border: 1px solid #E0E0E0; border-radius: 4px; padding: 20px 16px;">
                      <div style="font-size: 20px; color: #030303" class="fw-medium">Activity</div>
                      <ng-container *ngIf="candidateActivities.length > 0; else noActivities">
                        <div *ngFor="let item of candidateActivities">
                          <mat-expansion-panel class="custom-panel activity-panel bg-white" expanded="true">
                            <mat-expansion-panel-header class="bg-white px-0 pb-0">
                              <mat-panel-title>
                                {{ item.date | formatMonthYear }}
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div *ngFor="let activity of item.activities" class="activity-entry bg-white p-0" style="margin-top: 16px;">
                              <div class="d-flex flex-column">
                                <div class="d-flex flex-row">
                                  <div class="w-100">
                                    <div class="body-md fw-medium">{{ activity.title }}</div>
                                    <div>
                                      {{ activity.createdDate * 1000 | date }}
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex flex-row mt-1">
                                  <div class="w-100">
                                    <span class="body-md mat-color-gray-600">{{ activity.summaryDesc }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </div>
                      </ng-container>
                      <ng-template #noActivities>
                        <div style="margin-top: 16px;">No activity</div>
                      </ng-template>
                    </div>
                  </div>

                
              </ng-container>
            </div>
          </div>
        </mat-tab>
        <mat-tab class="edit-profile-tab">
          <ng-template mat-tab-label>
            <div class="custom-label d-flex align-items-center">
              <mat-icon class="md-icon-18 me-2 mat-primary">edit</mat-icon>
              <span class="mat-color-primary-500 fw-medium">Edit profile</span>
            </div>
          </ng-template>   
          <div class="tab-content d-block" style="padding: 37px 20px 20px; min-height: 70vh;">
            <div [formGroup]="candidateForm">
              <ng-container *ngIf="result.candidate">
                <div style="margin-bottom: 20px;">
                  <mat-expansion-panel class="custom-panel full-height bg-white" expanded="true" disabled="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="w-100 d-flex justify-content-between align-items-center me-0">
                        <span>Name</span>
                        <mat-icon class="md-icon-18 mat-primary" (click)="$event.stopPropagation(); showHideEditDetails[0] = !showHideEditDetails[0]">edit</mat-icon>  
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                      <div class="w-100" style="margin-top: 12px; margin-bottom: 12px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;" *ngIf="!showHideEditDetails[0]">
                        <div class="text-truncate">
                          <div class="mb-1 body-md text-truncate">First name</div>
                          <div class="body-lg fw-medium text-truncate">{{ result.candidate?.firstName }}</div>
                        </div>
                        <div class="text-truncate">
                          <div class="mb-1 body-md text-truncate">Last name</div>
                          <div class="body-lg fw-medium text-truncate">{{ result.candidate?.lastName }}</div>
                        </div>
                        <div class="text-truncate">
                          <div class="mb-1 body-md text-truncate">Preferred</div>
                          <div class="body-lg fw-medium text-truncate">{{ result.candidate?.preferredName }}</div>
                        </div>
                      </div>

                      <div class="w-100" style="margin-top: 12px; margin-bottom: 12px; display: grid; grid-template-columns: repeat(3, 1fr) 120px; gap: 16px; align-items: end;" *ngIf="showHideEditDetails[0]">
                        <div class="text-truncate">                      
                          <label class="body-md fw-medium text-truncate">First name</label>
                          <input type="text" class="form-control" formControlName="firstName" style="height: 44px; padding: 12px 16px; font-size: 16px;"/>
                        </div>
                        <div class="text-truncate">
                          <label class="body-md fw-medium text-truncate">Last name</label>
                          <input type="text" class="form-control" formControlName="lastName" style="height: 44px; padding: 12px 16px; font-size: 16px;"/>
                        </div>
                        <div class="text-truncate">
                          <label class="body-md fw-medium text-truncate">Preferred</label>
                          <input type="text" class="form-control" formControlName="preferredName" style="height: 44px; padding: 12px 16px; font-size: 16px;"/>
                        </div>
                        <div>
                          <button mat-flat-button color="primary" class="w-100 body-md" style="height: 44px;" (click)="saveName()">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div style="margin-bottom: 20px">
                  <mat-expansion-panel class="custom-panel full-height bg-white" expanded="true" disabled="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="w-100 d-flex justify-content-between align-items-center me-0">
                        <span>Location</span>
                        <mat-icon class="md-icon-18 mat-primary" (click)="$event.stopPropagation(); showHideEditDetails[1] = !showHideEditDetails[1]">edit</mat-icon>  
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                      <div class="w-100" style="margin-top: 12px; margin-bottom: 12px;" *ngIf="!showHideEditDetails[1]">
                        <div>
                          <div class="mb-1 body-md text-truncate">Location</div>
                          <div class="body-lg fw-medium text-truncate">{{ result.candidate?.cityState }}</div>
                        </div>
                      </div>

                      <div class="w-100 d-flex justify-content-between align-items-center" style="margin-top: 12px; margin-bottom: 12px;" *ngIf="showHideEditDetails[1]">
                        <div class="text-truncate">                      
                          <label class="body-md fw-medium text-truncate">Location</label>
                          <app-input-select
                            label=""
                            iconSuffix="search"
                            [subscriptSizingValue]="'dynamic'"
                            [api]="searchCitystate"
                            fieldClass="form-control-input-select mat-color-gray-600"
                            [text]="result.candidate?.cityState"
                            [value]="result.candidate?.geoId + ''"
                            (valueChange)="candidateForm.controls.geoId.setValue($event)">
                          </app-input-select>
                        </div>
                        
                        <button mat-flat-button color="primary" class="body-md" style="height: 44px;" (click)="saveLocation()">
                          Save
                        </button>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div style="margin-bottom: 20px">
                  <mat-expansion-panel class="custom-panel full-height bg-white" expanded="true" disabled="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="w-100 d-flex justify-content-between align-items-center me-0">
                        <span>Contact information</span>
                        <mat-icon class="md-icon-18 mat-primary" (click)="$event.stopPropagation(); showHideEditDetails[2] = !showHideEditDetails[2]">edit</mat-icon>  
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                      <div class="w-100" style="margin-top: 12px; margin-bottom: 12px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;" *ngIf="!showHideEditDetails[2]">
                        <div>
                          <div class="body-md text-truncate">Email</div>
                          <div class="mt-1 body-lg fw-medium text-truncate" *ngFor="let email of result.candidate?.emails">{{ email.email }} <span *ngIf="email.isPrimary" class="fw-normal">(Primary)</span></div>
                        </div>

                        <div>
                          <div class="body-md text-truncate">Phone number</div>
                          <div class="mt-1 body-lg fw-medium text-truncate" *ngFor="let phone of result.candidate?.phones">{{ phone.phoneNumber }} <span *ngIf="phone.isPrimary" class="fw-normal">(Primary)</span></div>
                        </div>
                      </div>

                      <div class="w-100" style="margin-top: 12px; margin-bottom: 12px;" *ngIf="showHideEditDetails[2]">
                        <app-contact-info [data]="getContactInfoData(result.candidate.phones, result.candidate.emails)" (hideEdit)="handleChildEvent()"></app-contact-info>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div style="margin-bottom: 20px; padding-bottom: 20px">
                  <mat-expansion-panel class="custom-panel full-height bg-white" expanded="true" disabled="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="w-100 d-flex justify-content-between align-items-center me-0">
                        <span>Work status</span>
                        <mat-icon class="md-icon-18 mat-primary" (click)="$event.stopPropagation(); showHideEditDetails[3] = !showHideEditDetails[3]">edit</mat-icon>  
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                      <div class="w-100">
                        <div style="margin-top: 16px; margin-bottom: 16px;" *ngIf="!showHideEditDetails[3]">
                          <div class="body-md text-truncate">Work status</div>
                          <div class="mt-1 body-lg fw-medium text-truncate">{{ result.candidate?.workStatusDesc }}</div>
                        </div>

                        <div>
                          <div class="w-100" style="margin-top: 12px; margin-bottom: 12px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;" *ngIf="!showHideEditDetails[3]">
                            <div class="text-truncate">
                              <div class="mb-1 body-md text-truncate">Desired range</div>
                              <div class="body-lg fw-medium text-truncate">
                                <span *ngIf="result.candidate?.minPayRate">${{ result.candidate?.minPayRate }}</span>
                                <span *ngIf="result.candidate?.minPayRate && result.candidate?.maxPayRate">&nbsp;-&nbsp;</span>
                                <span *ngIf="result.candidate?.maxPayRate">${{ result.candidate?.maxPayRate }}</span>
                                <span *ngIf="result.candidate?.payTypeDesc">&nbsp;{{ result.candidate?.payTypeDesc }}</span>
                              </div>
                            </div>
                            <div class="text-truncate">
                              <div class="mb-1 body-md text-truncate">Employment type</div>
                              <div class="body-lg fw-medium text-truncate">
                                <span *ngFor="let position of result.candidate?.positionTypes; let i = index">{{ i > 0 ? ',' : ''}} {{ position.positionTypeDesc }}</span>
                              </div>
                            </div>
                            <div class="text-truncate">
                              <div class="mb-1 body-md text-truncate">Earliest available date</div>
                              <div class="body-lg fw-medium text-truncate">{{ result.candidate?.availableDate | formatFullDate }}</div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="w-100" style="margin-top: 12px; margin-bottom: 12px;" *ngIf="showHideEditDetails[3]">
                        <div style="margin-top: 16px; margin-bottom: 16px;">
                          <div class="body-md fw-medium text-truncate">Work status</div>
                          <select class="form-select mt-1" formControlName="workStatusId" style="width: 330px; height: 44px; padding: 9px 16px; font-size: 16px;">
                            <option value="" disabled selected>Select work status</option>
                            
                            <ng-container *ngIf="{ WorkStatus: WorkStatus$ | async } as result">
                              <ng-container *ngIf="result.WorkStatus">
                                <option *ngFor="let item of result.WorkStatus" [value]="item.workStatusId">
                                  {{ item.workStatusDesc }}
                                </option>
                              </ng-container>
                            </ng-container>
                          </select>
                        </div>

                        <div *ngIf="showHideEditDetails[3]">
                          <ng-container *ngIf="{ payRateTypes: payRateTypes$ | async } as result">
                            <ng-container *ngIf="result.payRateTypes">
                                      
                              <div class="w-100 fw-medium py-1" style="border-bottom: 1px solid #E0E0E0" >
                                Work preferences
                              </div>
      
                              <div style="margin-top: 16px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;">
                                <div>
                                  <label class="fw-medium">Desired range</label>
                                  <div class="mt-1 d-flex align-items-start">
                                    <input type="number" placeholder="from" formControlName="minPayRate" class="form-control flex-shrink-0" style="margin-right: 8px; width: 22%; height: 44px; padding: 12px 16px; font-size: 16px;"/>
                                    <input type="number" placeholder="to" formControlName="maxPayRate" class="form-control flex-shrink-0" style="margin-right: 8px; width: 22%; height: 44px; padding: 12px 16px; font-size: 16px;"/>                                      
                                    <select class="form-select flex-grow-1" formControlName="payTypeId" style="height: 44px; padding: 9px 16px; font-size: 16px;">
                                      <option value="" disabled selected>Interval</option>

                                      <option *ngFor="let item of result.payRateTypes" [value]="item.payRateId">
                                        {{ item.payRateDesc }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <div>
                                  <label class="fw-medium">Employment type</label>
                                  <div class="w-100">
                                    <ng-container *ngIf="{ positionTypes: positionTypes$ | async } as result">
                                      <ng-container *ngIf="result.positionTypes">
                                        <mat-form-field class="w-100 mt-1 no-underline multi-mat" style="height: 44px; background-color: #fff !important" subscriptSizing="dynamic">
                                          <mat-select multiple="true" formControlName="positionTypeId">
                                            <mat-option *ngFor="let item of result.positionTypes" [value]="item.positionTypeId">
                                              {{ item.positionType }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </ng-container>
                                    </ng-container>
                                  </div>
                                </div>
                                <div>
                                  <label class="fw-medium">Earliest available date</label>
                                  <div class="mt-1">
                                    <mat-form-field subscriptSizing="dynamic" style="height: 44px;">
                                      <input matInput [matDatepicker]="picker1" formControlName="availableDate" />
                                      <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                      <mat-datepicker #picker1></mat-datepicker>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                              <div class="w-100 d-flex justify-content-end" style="margin-top: 16px;">
                                <button mat-flat-button color="primary" class="body-md" style="height: 44px;" (click)="saveWorkPreferences()">
                                  Save
                                </button>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>

                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
              </ng-container>
            </div>    
          </div> 
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <mat-divider></mat-divider>
</ng-container>

<ng-template #preview>
  <ng-container *ngIf="{ emailDetails: email$ | async } as email">
    <ng-container *ngIf="email.emailDetails">
      <div class="d-flex align-items-center mt-2" mat-dialog-title>
        <label class="text-primary">{{ email.emailDetails.jobTitle }}</label>
        <button mat-dialog-close mat-mini-fab color="primary" class="ms-auto">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-divider></mat-divider>

      <div class="mt-1" mat-dialog-content>
        <div class="d-flex">
          <div class="flex-column flex-grow-1">
            <!--From-->
            <div class="m-2">
              <label class="body-md pe-3"> From: </label>
              <label> {{ email.emailDetails.fromAddress }} </label>
            </div>

            <mat-divider></mat-divider>

            <!--To-->

            <div class="d-flex align-items-center m-2">
              <label class="body-md pe-3"> To: </label>

              <label class="   "> {{ email.emailDetails.toAddress }} </label>
            </div>

            <mat-divider style="font-size: 1rem"></mat-divider>

            <!--Subject-->
            <div class="d-flex m-2">
              <label class="body-md pe-3"> Subject: </label>

              <label> {{ email.emailDetails.subject }} </label>
            </div>

            <mat-divider></mat-divider>

            <!--Body-->
            <div class="d-flex mt-3" style="min-height: 21vw">
              <div class="p-3 emailBody pe-none" [innerHTML]="email.emailDetails.messageBody | safe : 'html'"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <mat-divider></mat-divider>
</ng-template>

 <ng-container *ngIf="jobInfo$ | async as jobInfo">
  <app-chat-view-container class="jobs-id-page" [jobId]="data.jobId" [jobInfo]="jobInfo.info[0]"></app-chat-view-container>
</ng-container>
